<template>
  <section>
    <div class="text-center">
      <h2 class="mt-6 text-3xl font-bold text-gray-300">
        {{ code_validate ? "Verificação por SMS" : "Cadastrar-se" }}
      </h2>

      <p class="mt-2 whitespace-normal text-xs text-gray-400" v-if="code_validate">
        Verifique o código enviado para o número {{ number_phone_code }}.
      </p>
      <p class="mt-2 whitespace-normal text-xs text-gray-400" v-else-if="partnerName">
        Faça seu cadastro agora e aproveite todos os benefícios exclusivos desta parceria OnTick com a
        {{ partnerName }}.
      </p>
      <p class="mt-2 whitespace-normal text-xs text-gray-400" v-else>
        Crie sua conta gratuitamente e comece agora mesmo a investir de forma totalmente automatizada.
      </p>
    </div>
    <div is="transition" v-on:enter="enter" v-on:leave="leave" v-bind:css="false" appear mode="out-in">
      <div :key="1" v-if="!code_validate" class="mt-6 space-y-6">
        <ontick-input
          placeholder="Ontickerson Silva"
          v-model="user.full_name"
          label="Nome completo"
          name="full_name"
          type="text"
          v-validate="'required'"
          :error="errors.first('full_name')"
          bg="bg-ontick-steel-500"
        ></ontick-input>

        <ontick-input
          placeholder="000.000.000-00"
          v-model="user.usercpf"
          label="CPF"
          name="usercpf"
          type="text"
          v-validate="'required|min:14'"
          v-mask="mask_cpf"
          :error="errors.first('usercpf')"
          bg="bg-ontick-steel-500"
        ></ontick-input>

        <ontick-input
          placeholder="ontick@ontick.com.br"
          v-model="user.email"
          label="Email"
          name="email"
          type="email"
          v-validate="'required|email'"
          :error="errors.first('email')"
          bg="bg-ontick-steel-500"
        ></ontick-input>

        <ontick-input
          placeholder="11 99999-9999"
          v-model="user.phone_number"
          label="Telefone"
          name="userphone"
          type="text"
          v-validate="'required|length:13'"
          v-mask="'## #####-####'"
          :error="errors.first('userphone')"
          bg="bg-ontick-steel-500"
        ></ontick-input>
        <password-validate
          label="Senha"
          ref="password"
          name="password"
          v-model="user.password"
          v-validate="'required'"
          :error="errors.first('password')"
          bg="bg-ontick-steel-500"
          autocomplete="sdfbaovihb"
        />
        <div class="inline-block items-center justify-between pb-6">
          <div class="flex items-center">
            <input
              @click="user.terms_of_user = !user.terms_of_user"
              name="remember-me"
              type="checkbox"
              v-validate="'required'"
              v-model="user.terms_of_user"
              :class="errors.has('remember-me') ? 'border-ontick-red-500' : 'border-gray-300'"
              class="h-4 w-4 rounded text-ontick-blue-600 focus:ring-ontick-blue-500"
            />
            <label @click="$emit('termsOfUser')" for="terms_of_user" class="ml-2 block text-sm text-gray-300">
              Aceitar
              <span class="cursor-pointer text-ontick-blue-500">termo de uso</span>
            </label>
          </div>
          <p v-if="errors.has('remember-me')" class="text-xs text-ontick-red-500">Termo de uso obrigatório</p>
        </div>
        <ontick-button @click.native="signUp()" class="w-full">
          <span v-show="!loading_buttons">Cadastrar</span>
          <span v-show="loading_buttons" v-html="$icons.loading"></span>
        </ontick-button>

        <div class="space-y-6 text-center">
          <div class="border border-ontick-steel-500"></div>
          <div class="text-sm">
            <p class="text-gray-300">Já é cadastrado?</p>
            <p @click="$emit('returnLogin')" class="cursor-pointer font-medium text-ontick-blue-600">Faça login!</p>
          </div>
        </div>
      </div>
      <div :key="2" v-else>
        <div is="transition" v-on:enter="enter" v-on:leave="leave" v-bind:css="false" appear mode="out-in">
          <div :key="3" v-if="!code_status" class="space-y-6">
            <div>
              <label for="code" class="block text-sm font-medium text-gray-300"> Código </label>
              <div class="mt-1">
                <PincodeInput v-model="user.auth_code" :secure="false" :characterPreview="false" :length="6" />
              </div>
            </div>
            <div class="py-3">
              <a
                v-show="!resend_code"
                @click="resendConfirmationCode()"
                class="cursor-pointer text-right text-xs font-medium text-ontick-blue-500"
                >Reeviar código</a
              >
              <contador v-if="resend_code" />
            </div>
            <ontick-button @click.native="confirmSignUp()" class="w-full">
              <span v-show="!loading_buttons">Confirma código</span>
              <span v-show="loading_buttons" v-html="$icons.loading"></span>
            </ontick-button>
          </div>
          <div :key="4" v-else class="flex justify-center">
            <div class="py-16">
              <success-icon :active="code_status" title="Cadastro realizado com sucesso" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PincodeInput from "vue-pincode-input";
import PasswordValidate from "./password.validate.component.vue";
import Contador from "@/app/shared/components/contador/timer.component.vue";
import SuccessIcon from "@/app/shared/components/basic/ontick-success.component.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import filter from "@/app/shared/filters/filter.js";
import { Auth } from "aws-amplify";
export default {
  props: {
    partnerName: {
      type: String,
    },
  },

  data() {
    return {
      user: {
        username: "",
        full_name: "",
        email: "",
        password: "",
        confirm_password: "",
        phone_number: "",
        phone_number_format: "",
        usercpf: "",
        terms_of_user: false,
        auth_code: "",
      },

      active_modal: true,

      number_phone_code: null,
      code_validate: false,

      resend_code: false,
      code_status: false,

      loading_buttons: false,

      translations: {
        countrySelectorLabel: "Cód. pais",
        countrySelectorError: "Pais não encontrado.",
        phoneNumberLabel: "Número telefone",
        example: "Examplo:",
      },
    };
  },

  mixins: [filter],

  components: {
    SuccessIcon,
    PasswordValidate,
    VuePhoneNumberInput,
    PincodeInput,
    Contador,
  },

  methods: {
    enter(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    updatePhone(event) {
      if (event.isValid);
      this.user.phone_number_format = event.formattedNumber;
    },

    signUp() {
      let UserAttributes = {
        "custom:user_cpf": this.user.usercpf.replace(/[^\d]/g, ""),
        "custom:full_name": this.user.full_name,
        "custom:accecpted_terms": this.user.terms_of_user ? "1" : "0",
        "custom:partner": this.$route.query.bra ? "bra" : "ontick",
        email: this.user.email,
        phone_number: `+55${this.user.phone_number.replaceAll("-", "").replaceAll(" ", "")}`,
      };

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading_buttons = true;
          Auth.signUp({
            username: this.user.email,
            password: this.user.password,
            attributes: UserAttributes,
          })
            .then((response) => {
              this.number_phone_code = response.codeDeliveryDetails.Destination;
              this.code_validate = true;
            })
            .catch((error) => {
              this.$swal({
                title:
                  error.message == "An account with the given email already exists."
                    ? "Já existe uma conta com o e-mail fornecido."
                    : error.message,
                icon: "error",
                timer: 150000,
              });
              if (error.message == "An account with the given email already exists.") {
                Auth.resendSignUp(this.user.email)
                  .then((response) => {
                    this.code_validate = true;
                    this.number_phone_code = response.CodeDeliveryDetails.Destination;
                  })
                  .catch((error) => {
                    console.error("ERROR", error);
                  });
              }
            })
            .finally(() => {
              this.loading_buttons = false;
            });
        }
      });
    },

    confirmSignUp() {
      this.loading_buttons = true;
      Auth.confirmSignUp(this.user.email, this.user.auth_code)
        .then(() => {
          this.code_status = true;
          setTimeout(() => {
            this.$emit("returnLogin");
          }, 4000);
        })
        .catch((error) => {
          this.$swal({
            title: error.message,
            icon: "error",
            timer: 5000,
          });
        })
        .finally(() => {
          this.loading_buttons = false;
        });
    },

    resendConfirmationCode() {
      this.loading_buttons = true;
      Auth.resendSignUp(this.user.email)
        .then(() => {
          this.resend_code = true;
          setTimeout(() => {
            this.resend_code = false;
          }, 60000);
        })
        .catch((error) => {
          this.$swal({
            title: error.message,
            icon: "error",
            timer: 5000,
          });
        })
        .finally(() => {
          this.loading_buttons = false;
        });
    },
  },

  watch: {
    user: {
      deep: true,
      handler(val) {
        console.log(val.phone_number_format);
      },
    },
  },
};
</script>
<style lang="scss">
div.vue-pincode-input-wrapper {
  @apply flex justify-center space-x-6;
}

input.vue-pincode-input {
  @apply bg-ontick-graphite-500 text-xl font-medium text-gray-300 shadow-lg;
  max-width: 43px;
  max-height: 43px;
  margin: 0px;
  transition: all 0.3s ease;
  &:focus {
    border: 2px solid #07a4ff;
  }
}
.input-tel__input {
  font-family: "Poppins", sans-serif !important;
  @apply border  border-ontick-carbon-500 bg-ontick-steel-500 text-sm font-normal text-gray-300 #{!important};
}

.vue-phone-number-input {
  font-family: "Poppins", sans-serif !important;
}

.country-selector__input {
  font-family: "Poppins", sans-serif !important;
  @apply w-full border border-ontick-carbon-500 bg-ontick-steel-500 text-sm font-medium text-gray-300 #{!important};
}

.country-selector__label {
  font-family: "Poppins", sans-serif !important;
  @apply text-[9px] text-gray-400 #{!important};
}

.input-tel__label {
  font-family: "Poppins", sans-serif !important;
  @apply text-[9px] text-gray-400 #{!important};
}

.country-selector__toggle__arrow {
  @apply text-gray-300 #{!important};
}

.country-selector__list {
  @apply bg-ontick-steel-500 text-gray-300 #{!important};
}
</style>
